import PL_utils from '../patterns/pl-utils.js';

const urlLocation = window.location;

const createCookie = (name, value, expires, path='/', domain) => {
    var cookie = name + '=' + escape(value) + ';';
    var date = new Date();
    //set expire for one week
    date.setTime(date.getTime() + 7*24*60*60*1000);
    cookie += 'expires=' + date.toGMTString() + ';';
    
    if (path) {
        cookie += 'path=' + path + ';';
    }
    if (domain) {
        cookie += 'domain=' + domain + ';';
    }
    if (location.protocol === 'https:') {
        cookie += "SameSite=None;Secure;";
    }
    document.cookie = cookie;
};

const getCookie = name =>
    new RegExp(name + '=([^;]+)').exec(document.cookie) != null
        ? unescape(new RegExp(name + '=([^;]+)').exec(document.cookie)[1])
        : "null";
    
const updateCookie = () => {
    if (urlLocation.href.indexOf('sign-up') < 0) {
        createCookie("takemethere",urlLocation.pathname + urlLocation.search)
    }
}


export default () => {
    const preheaderGetUpdates = document.querySelectorAll('.preheader-menu__link--signup');
    const bodyGetUpdates = document.querySelectorAll('.btn-getupdates');
    const takeMeThereBtn = document.querySelector('.take-me-there');
    var TakeMeThereUrl = getCookie('takemethere');

    if (urlLocation.href.indexOf('sign-up') < 0) {
        createCookie("takemethere","/") //default to homepage
    }

    PL_utils.eleOnClick(function (e) {
        updateCookie();
    }, preheaderGetUpdates);

    PL_utils.eleOnClick(function (e) {
        updateCookie();
    }, bodyGetUpdates);

    if ( TakeMeThereUrl && takeMeThereBtn ) {
        takeMeThereBtn.setAttribute('href', TakeMeThereUrl);
    }
   
};